<mat-dialog-content>
  <div id="promo-code-form" class="promo-code-form">
    <div mat-dialog-title class="fz-dialog__close">
      <button
        mat-icon-button
        (click)="closeModal('close', $event)"
        data-ga-value="close-promo-code-modal"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="fz-dialog">
      <form class="fz-dialog__root" [formGroup]="form" autocomplete="off">
        <div class="fz-dialog__picture">
          <picture>
            <img
              src="/shared/svg/{{
                colorScheme === ColorScheme.Dark
                  ? 'promote-code-dark'
                  : 'promote-code'
              }}.svg"
              alt="Promo code"
              width="200px"
              height="200px"
            />
          </picture>
        </div>
        <div class="fz-dialog__head">
          <h2 class="mat-display-small">Have a promo code?</h2>
        </div>
        <div class="fz-dialog__content">
          <div>
            <mat-form-field class="full-width">
              <mat-label>Promo Code</mat-label>
              <input
                matInput
                id="promoCodeField"
                formControlName="promoCode"
                required
                type="text"
                autocomplete="promo-code"
                oninput="this.value = this.value.toUpperCase()"
              />
              <mat-error
                class="mat-caption"
                *ngIf="form.get('promoCode')?.hasError('pattern')"
              >
                The code is <b>invalid</b>, please check it and try entering it
                again
              </mat-error>
              <mat-error
                class="mat-caption"
                *ngIf="form.get('promoCode')?.hasError('required')"
              >
                The code is <b>required</b>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="fz-dialog__actions">
          <ng-container *ngrxLet="data.submitting as submitting">
            <button
              mat-flat-button
              type="submit"
              [disabled]="submitting"
              class="fz-button--medium"
              color="primary"
              data-ga-value="confirm-promo-code"
              [class]="{ 'mat-button-loading': submitting }"
              (click)="onFormSubmit()"
            >
              Apply
            </button>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>
